var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.type !== 'svg')?_c('i',{class:_vm._class}):_c('img',{attrs:{"src":_vm.path}})
}
var staticRenderFns = []

export { render, staticRenderFns }